// extracted by mini-css-extract-plugin
export default {"option":"OptionSelect_option__0xQUo","focado":"OptionSelect_focado__TP0fV"};